export default class GKSCommonInterface {
  constructor(gks) {
    this.clientId = gks.clientId;
    this.version = gks.version ?? '';
    this.mainColor = gks.mainColor ?? '';
    this.backgroundColor = gks.backgroundColor ?? '';
    this.textFont = gks.textFont ?? '';
    this.hiddenGuests = gks.hiddenGuests ?? true;
  }
}
